import { UserType } from 'types/user.type';
import { getRefreshToken, removeAccessToken, setRedirectUrl, toQuery } from '../utils';
import { axios, get } from './axios';
import {AUTHORIZATION_URL, GET_TOKEN_URL} from '../commons/constants';

interface AuthorizeType {
  client_id: string;
  scope: string;
  redirect_uri: string;
  response_type: string;
  state?: string;
}

const contextPath = process.env.REACT_APP_API_VERSION;
const authorizationUrl = AUTHORIZATION_URL;
const getTokenUrl = GET_TOKEN_URL;
const clientId = process.env.REACT_APP_CLIENT_ID;
const clientSecret = process.env.REACT_APP_CLIENT_SECRET;
const redirectUri = process.env.REACT_APP_REDIRECT_URI;
const state = '12345';
const scope = 'read';
const responseType = 'code';

const getUserDetail = (): Promise<{ data: UserType }> => {
  return get(`${contextPath}/user/profile`);
};
const getToken = ({ code, onSuccess }: { code: string; onSuccess: () => void }): void => {
  const payload = {
    grant_type: 'authorization_code',
    client_id: clientId,
    client_secret: clientSecret,
    code: code,
    redirect_uri: redirectUri,
  };
  const search = toQuery(payload);
  fetch(`${getTokenUrl}?${search}`)
    .then((res) => {
      if (res.ok) {
        return res.json();
      }
      throw new Error('fetch token error');
    })
    .then((data) => {
      axios.setToken(data);
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch((err) => {
      console.error(err);
    });
};
const refreshToken = ({ onSuccess }: { onSuccess: () => void }): void => {
  const formData = new FormData();
  formData.append('grant_type', 'refresh_token');
  formData.append('client_id', clientId);
  formData.append('client_secret', clientSecret);
  formData.append('refresh_token', getRefreshToken());
  fetch(`${getTokenUrl}`, {
    method: 'POST',
    body: formData,
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      }
      throw new Error('refresh token error');
    })
    .then((data) => {
      axios.setToken(data);
      if (onSuccess) onSuccess();
    })
    .catch((err) => {
      console.error(err);
      removeAccessToken();
      authorize();
    });
};
const authorize = (): void => {
  const payload: AuthorizeType = {
    client_id: clientId,
    scope,
    redirect_uri: redirectUri,
    response_type: responseType,
  };
  if (state) {
    payload.state = state;
  }
  const search = toQuery(payload);
  setRedirectUrl(window.location.href);
  window.location.href = `${authorizationUrl}?${search}`;
};

export { getUserDetail, authorize, getToken, redirectUri, responseType, refreshToken };
